import dynamic from "next/dynamic";

/*
 * `LokaliseMarkdownText` behind `next/dynamic`, for app-shell callers only
 * (`useMerchantTOS`, called straight from `_app`). A static import there would
 * put markdown-to-jsx's ~102 KB parser in the shared _app chunk and tax every
 * page for a modal footer.
 *
 * Only for markdown that is never in the server HTML: on the first client
 * render a lazy component can still be loading, and anything the server did
 * render would then fail hydration (#418). Server-rendered markdown uses
 * `LokaliseMarkdownText` directly.
 */
export const LazyLokaliseMarkdownText = dynamic(() =>
  import("@/components/text/LokaliseMarkdownText").then(
    module => module.LokaliseMarkdownText
  )
);
